import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { useLocation ,useParams} from "react-router-dom";
import { useWindowWidth } from "@react-hook/window-size";

import Translate from "../Multilanguage/Translate";
import { isHTML, rowItemCount } from "../../utils/utils";
import useScrollPosition from "../ScrollPosition/useScrollPosition";
import * as service from "./service";
import ShowCard from "../ShowCard/ShowCard";
import Loading from "../Loading/Loading";



const ChannelsPage = () => {

  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const containerRef = useRef(null);
  const scrollPosition = useScrollPosition();
  const { careers } = useParams();
  const windowSize = useWindowWidth();
  const location = useLocation();

  const [channels, setChannels] = useState([]);
  const [img, setImg] = useState(true);
  const [rowItemsClass,setRowItemsClass] = useState("");
  const [sliceCount,setSliceCount] = useState(20);
  const [isExpanded, setIsExpanded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [channelsReady, setChannelsReady] = useState(false);


  const template = projectInfo?.projectConfig?.config?.TEMPLATE;  
  const theme = projectInfo?.projectConfig?.config?.THEME; 
  const thumbnailOrientation = (location?.state?.thumbnailOrientation) ? (location?.state?.thumbnailOrientation):( projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION);
  const type = location?.state?.type;
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  

  useEffect(() => {
    fetchChannelsDetails();
  }, [location.pathname, careers]);

  useEffect(() => {
    if(windowSize>980){
        if(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT){
          setRowItemsClass(rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT))
        }else{
          setRowItemsClass("rowCount4")
        }
    }else{
        setRowItemsClass("")
      }
    }, [projectInfo,windowSize]);

  useEffect(()=>{
        if(!loading && sliceCount<channels?.channels?.length){
          lazyLoad()
        }
      },[loading,scrollPosition,channels])

  useEffect(() => {
    const timer = setTimeout(() => {
      setChannelsReady(true);
    }, 100); // Small delay to ensure state is set

    return () => clearTimeout(timer);
  }, [channels]);

  const  fetchChannelsDetails= async () => {
    setLoading(true)
    setChannelsReady(false) // Reset channels ready state
    try {
      const channelResponse = await service.getChannels(appInfo, careers);
      
      if (channelResponse?.status === 200) {
        setChannels(channelResponse?.data?.categories);
        setImg(false);
        setLoading(false);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "top-center",
       });
      setLoading(false);

    }
  };
  const lazyLoad = () => {
    const containerHeight = containerRef?.current?.clientHeight;
    if(scrollPosition + 2200 >= containerHeight){
      setSliceCount(sliceCount+20)
    }
  }
  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  if(loading){
    return(
      <Loading/>
    )
  }

  return (
       <div className={`channels-page ${isRTL ? "rtl" : ""} ${template === "TEMPLATE_10" ? (channels?.banner ? "gaia":"gaia-banner") : ""}`} ref={containerRef} role="region" aria-label="Common Page Section">
            <ToastContainer />
            {
              console.log(channels?.length,"channels?.length",loading,"loading")
              
            }
            {(!loading && (channels?.length === 0 || Object.entries(channels).length === 0) ?  (
              <h1
                style={{
                  color: "#E72A31",
                  display:"flex",
                  justifyContent:'center',
                  padding:'100px',
                }}
                className={`${template === "TEMPLATE_10" ? "gaia" : "no-data"}`}
                role="alert"
                aria-live="assertive"
              >
                <Translate textKey={'no_data_found'} />
              </h1>
            ) : (
              <>
                {channels?.banner ? (
                  <div
                    className={`${( projectInfo?.projectConfig?.pubid===50146 ||template === "TEMPLATE_9" && !isExpanded) ? 'bannerContainer' : 'bgImageContainer'}`}
                    style={{
                      backgroundImage: template === "TEMPLATE_9"
                        ? `linear-gradient(90deg, #000 0%, transparent), url(${channels?.banner})`
                        : `url(${channels?.banner})`,
                     
                    }}
                  >
                      <div className="topContainer">
                      <div className={template === "TEMPLATE_9" ? "topbanner" : "top"}>
                        <h1 className={`heading  ${template === "TEMPLATE_10" ? "gaia" : ""}  ${theme === "LIGHT" ? (channels?.banner ?"light-theme":"light-noBg") : ""} `}> {channels?.category_name}</h1>
                        <p className="desc">
                         {(() => {
                              const rawSynopsis = channels?.synopsis || ""; 
                            const synopsis = template !== "TEMPLATE_9"
                              ? rawSynopsis
                              : isExpanded || rawSynopsis.split(" ").length <= 70
                                ? rawSynopsis
                                : `${rawSynopsis.split(" ").slice(0, 70).join(" ")}...`;
                            if (isExpanded && isHTML(synopsis)) {
                              return <span dangerouslySetInnerHTML={{ __html: synopsis }} />;
                            }
                            return (
                              template === "TEMPLATE_9" ? (
                              <span className="desc"
                                dangerouslySetInnerHTML={{
                                  __html: (synopsis || "").replace(/<br\s*\/?>/gi, "\n").replace(/<\/p>/gi, "\n").replace(/<[^>]+>/g, "").replace(/\n+/g, "\n")
                                }}
                              />
                              ) : (
                                <span
                                dangerouslySetInnerHTML={{
                                  __html: (synopsis || "").replace(/\n/g, "<br>")
                                }}
                              />
                              )
                            );
                          })()}
                          {!isExpanded && template === "TEMPLATE_9" && (channels?.synopsis || "").split(" ").length > 70 && (
                            <span className="see"
                              onClick={toggleDescription}
                            >
                              <Translate textKey={"see_more"} />
                            </span>
                          )}
                          {isExpanded && template === "TEMPLATE_9" && (channels?.synopsis || "").split(" ").length > 70 && (
                          <span className="see"
                            onClick={toggleDescription}
                          >
                            <Translate textKey={"see_less"} />
                          </span>
                          )}
                        </p>
                      </div>

                      <div
                        className="bottomGradient"
                        style={{ background: template === "TEMPLATE_9" ? "none" : "" }}
                      />
                      </div>
                    </div>
                  ) : (
                   channels?.synopsis?
                      <div className="descTopContainer">
                      <div className={template === "TEMPLATE_9" ? "topbannerDesc" : "topDesc"}>
                         <h1 className={`heading  ${template === "TEMPLATE_10" ? "gaia" : ""}  ${theme === "LIGHT" ? (channels?.banner ?"light-theme":"light-noBg") : ""} `}> {channels?.category_name}</h1>
                         <p className="desc">
                          {(() => {
                            const synopsis = template !== "TEMPLATE_9"
                              ? channels?.synopsis
                              : isExpanded || (channels?.synopsis || "").split(" ").length <= 70
                                ? channels?.synopsis
                                : `${(channels?.synopsis || "").split(" ").slice(0, 70).join(" ")}...`;
                            if (isExpanded && isHTML(synopsis)) {
                              return <span dangerouslySetInnerHTML={{ __html: synopsis }} />;
                            }
                            return (
                              template === "TEMPLATE_9" ? (
                              <span className="desc"
                                dangerouslySetInnerHTML={{
                                  __html: (synopsis || "").replace(/<br\s*\/?>/gi, "\n").replace(/<\/p>/gi, "\n").replace(/<[^>]+>/g, "").replace(/\n+/g, "\n")
                                }}
                              />
                              ) : (
                                <span
                                dangerouslySetInnerHTML={{
                                  __html: (synopsis || "").replace(/\n/g, "<br>")
                                }}
                              />
                              )
                            );
                          })()}
                          {!isExpanded && template === "TEMPLATE_9" && (channels?.synopsis || "").split(" ").length > 70 && (
                            <span className="see"
                              onClick={toggleDescription}
                            >
                              <Translate textKey={"see_more"} />
                            </span>
                          )}
                          {isExpanded && template === "TEMPLATE_9" && (channels?.synopsis || "").split(" ").length > 70 && (
                          <span className="see"
                            onClick={toggleDescription}
                          >
                            <Translate textKey={"see_less"} />
                          </span>
                          )}
                        </p>
                      </div>
                     
                      <div
                        className="bottomGradient"
                        style={{ background: template === "TEMPLATE_9" ? "none" : "" }}
                      />
                      </div> :

                       <div className="top">
                      <h1  className={`heading  ${template === "TEMPLATE_10" ? "gaia" : ""}  ${theme === "LIGHT" ? (channels?.banner ?"light-theme":"light-noBg") : ""}`}> {channels?.category_name}</h1>
                      <p className="desc">
                        {isHTML(channels?.synopsis)
                          ? <span dangerouslySetInnerHTML={{ __html: channels?.synopsis }} />
                          : channels?.synopsis}
                      </p>
                      </div>
                  )}
      
                <div className="wrapper">
                  <div className="bottom">
                    <div className="itemsContainer" aria-label="Category channels">  
                      {
                        channels?.slice(0,sliceCount)?.map((item, index) => (
                          <div
                            className={thumbnailOrientation===`PORTRAIT`? projectInfo?.projectConfig?.pubid === 50134 ? `items portrait rowCount6` : `items portrait ${rowItemsClass}`:`items landscape ${rowItemsClass}`}
                          >
                            <ShowCard
                              data={item}
                              key={index}
                              imageUrl={img}
                              season={false}
                              metaData={true}
                              type={type}
                              thumbnailOrientation ={thumbnailOrientation}
                              categoryName={channels?.category_name}
                              tabIndex={0}
                              role="button"
                              aria-label={item?.show_title || "Show"}
                            />
                            
                          </div>
                        ))
                       }
                    </div>
                  </div>
                </div>
              </>
            ))}
        </div>
  );
};

export default ChannelsPage;
